<script>
  import AuthorPill from './AuthorPill/AuthorPill.svelte';
  import WallsWidgetService from './service';
  import { External, M } from '../../external';

  export let post, onApprovePost, onEditPost, onDeletePost, hasRepliesFetched, onCollapse, onExpand;

  let isPostBelongToMember = false;
  WallsWidgetService.isPostBelongToMember(post).then((res) => (isPostBelongToMember = res));
  let isModerator = false;
  WallsWidgetService.isModerator().then((res) => (isModerator = res));

  const thread = {
    state: 'expanded',
    toggle: () => {
      thread.state = thread.state === 'expanded' ? 'collapsed' : 'expanded';
      if (thread.state === 'expanded') {
        onExpand();
      } else {
        onCollapse();
      }
    }
  };

  const postOptions = {
    open: false,
    toggle: () => {
      postOptions.open = !postOptions.open;
    },
    close: () => {
      postOptions.open = false;
    }
  };

  const copyCommentIdToClipboard = function (commentId) {
    External.Tools.copyToClipboard(commentId);
    External.Tools.showCornerMessage(1000, M.COPIED_TO_CLIPBOARD, External.Tools.TOOLTIP_TYPE_SUCCESS);
  };

  let optionsBtn;
  const showOptions = () => {
    const target = External.$(optionsBtn);
    const options = [];
    if (!post.approved) {
      options.push({ text: M.APPROVE, icon: 'fa-check', tag: 'approve' });
    }
    if (isPostBelongToMember) {
      options.push({ text: M.EDIT, icon: 'fa-pencil', tag: 'edit' });
    }
    options.push({ text: M.DELETE, icon: 'fa-trash', tag: 'delete' });
    options.push({ text: M.COPY_POST_ID, icon: 'fa-clipboard', tag: 'copy' });
    External.Tools.showTooltipOptions(target, options, async (target, idx, text, tag) => {
      switch (tag) {
        case 'approve':
          onApprovePost();
          break;
        case 'edit':
          onEditPost();
          break;
        case 'delete':
          onDeletePost(post);
          break;
        case 'copy':
          copyCommentIdToClipboard(post.id);
          break;
      }
    });
  };

  export const toggle = () => {
    thread.toggle();
  };
</script>

<header class="col20 f-lef flex align-center space-between">
  <div class="flex align-center">
    <AuthorPill
      author={post.author}
      timestamp={post.timestamp}
      showBadge="true"
      isWaitingApproval={!post.approved}
      {onApprovePost} />
  </div>
  <div class="flex-none">
    <div
      class:none={!hasRepliesFetched}
      on:click={thread.toggle}
      class="circle-round-btn circle-effect f-left mr-5 collapse">
      {#if thread.state === 'collapsed'}
        <svg xmlns="http://www.w3.org/2000/svg" class="expand-icon" height="24" viewBox="0 -960 960 960" width="24">
          <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
        </svg>
      {:else}
        <svg xmlns="http://www.w3.org/2000/svg" class="collapse-icon" height="24" viewBox="0 -960 960 960" width="24">
          <path d="M200-440v-80h560v80H200Z" />
        </svg>
      {/if}
    </div>
    <div bind:this={optionsBtn} on:click={showOptions} class="circle-round-btn circle-effect f-left">
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
      </svg>
    </div>
  </div>
</header>
